import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import { formatNumber, shouldHideField } from "../../../utils/numberFormatting";

import { isDefined, functor } from "../utils";
import { getSourcePathLabel } from "../utils/getSourcePath";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class BollingerPercentBTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      className,
    } = this.props;
    const { options, labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;
    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const percentB = isDefined(currentItem) && yAccessor(currentItem);
    const value = (percentB && displayFormat(percentB)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Hide tooltip if value is n/a
    if (shouldHideField(value)) {
      return null;
    }

    // Build tooltip label
    const period = options.windowSize || 20;
    const stdDev = options.multiplier || 2;
    const maType = options.movingAverageType || "sma";
    const sourcePath = options.sourcePath || "close";
    const sourceLabel = getSourcePathLabel(sourcePath);

    const tooltipLabel = `Bollinger %b (${period}, ${maType.toUpperCase()}, ${stdDev}σ, ${sourceLabel}): `;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-bollinger-percent-b"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{value}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

BollingerPercentBTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  options: PropTypes.shape({
    windowSize: PropTypes.number.isRequired,
    multiplier: PropTypes.number.isRequired,
    movingAverageType: PropTypes.string,
    sourcePath: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
};

BollingerPercentBTooltip.defaultProps = {
  displayFormat: (d) => formatNumber(d, 2),
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default BollingerPercentBTooltip;
